<script>
import { forEach } from 'lodash';

import Constants from '../constants';

import commonFooter from '@/components/commonFooter';
import commonNav from '@/components/commonNav';
import moveTextHover from '@/components/moveTextHover';
import shareBtn from '@/components/shareBtn';
import youtubeContainer from '@/components/youtubeContainer';
import youtubeContainerShorts from '@/components/youtubeContainerShorts.vue';
import hoverDesign from '@/components/hoverDesign';
import pageTitle from '@/components/pageTitle';

import setMetaUtil from '@/util/setMetaUtil';

import { imagesLoad } from '@/util/assetLoadUtil';

import img1 from '@/assets/img/demo/1.jpg';
import boothBanner from '@/assets/img/banner/company/booth-l.png';



export default {
  name: Constants.ROUTER.DEMO,
  components: {
    commonFooter,
    commonNav,
    moveTextHover,
    shareBtn,
    youtubeContainer,
    youtubeContainerShorts,
    hoverDesign,
    pageTitle,
  },
  data() {
    return {
      cdList: [],
      ready: false,
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      setMetaUtil.setMeta(this, document,
        `${this.$i18n.messages.ja.message.demo.pageName} - ${this.$i18n.messages.ja.message.bandName}`,
        this.$i18n.messages.ja.message.demo.description,
      );
      document.dispatchEvent(new Event('custom-render-trigger'));

      window.onscroll = () => { this.onscroll(); }
      window.onresize = () => { this.onscroll(); }
      this.onscroll();

      this.cdList = [];
      forEach(this.$t('message.demo.list'), (v) => {
        this.cdList.unshift(v);
      });

      this.cdList.forEach((cd) => {
        cd.tracklist = [];
        forEach(cd.tracks, (track) => {
          cd.tracklist.push(track);
        });
      });

      await imagesLoad([
        img1,
        boothBanner,
      ]);

      setTimeout(() => {
        this.ready = true;
        this.moveTo();
      }, 1);


    },
    onscroll() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },

    moveTo() {
      const id = this.$route.query.id;
      if (!id) { return; }
      const ref = this.$refs[`ref${id}`];
      if (ref.length > 0) {
        const top = ref[0].getBoundingClientRect().top;
        // commonNavHeight分引く
        window.scroll({
          top: top - 50,
          left: 0,
          behavior: "smooth",
        });
      }
    }
  }
};
</script>

<template>
  <div class="view-demo page" :class="[ready ? 'is-ready' : '', $mq]">
    <common-nav />
    <div id="contents-main" :style="{ 'min-height': windowHeight + 'px' }">

      <page-title :title-text="$t('message.demo.pageName')" title-type="sun" />

      <div class="cd-item" v-for="(cdItem, i) in cdList" :key="cdItem.id"
        :class="[`is-${cdItem.id}`, (i % 2 === 1) ? 'odd' : 'even']" :ref="`ref${cdItem.id}`">
        <div class="jacket"></div>
        <div class="info-container">

          <div class="common-info">
            <div class="title" :title="cdItem.name">{{ cdItem.name }}</div>
            <div class="date">{{ cdItem.date }} / {{ cdItem.event }}</div>
            <div v-if="cdItem.booth !== ''" class="free">{{ $t('message.demo.free') }}</div>
          </div>

          <div class="contents">
            <a class="booth" v-if="cdItem.booth !== ''" :title="$t('message.shop.booth')" target="_blank"
              :href="cdItem.booth">
              <hover-design />
            </a>

            <div class="youtube" v-for="youtubeUrl in cdItem.youtube" :key="youtubeUrl">
              <youtube-container :file-url="youtubeUrl" />
            </div>

            <div class="youtubeShort" v-for="youtubeShortUrl in cdItem.youtubeShort" :key="youtubeShortUrl">
              <youtube-container-shorts :file-url="youtubeShortUrl" />
            </div>
            
          </div>

          <div class="tracks">
            <div class="track" v-for="(track, ii) in cdItem.tracklist" :key="ii">
              {{ ii + 1 }}. {{ track }}
            </div>
          </div>
        </div>

      </div>
    </div>
    <common-footer />
    <share-btn :is-fixed="true" />
  </div>
</template>

<style lang="scss" scoped>
@import "../css/variables";

.page {
  position: relative;

  #contents-main {
    padding-top: $commonNavHeight * 2;

    .cd-item {
      display: flex;
      width: 100%;
      min-height: 400px;
      margin: 30px 0 100px 0;

      .jacket {
        @include bgCenter;
        background-position:  50% 0;
        width: 400px;
      }

      &.is-1 .jacket { background-image: url(../assets/img/demo/1.jpg); }
      &.is-2 .jacket { background-image: url(../assets/img/demo/2.jpg); }
      &.is-3 .jacket { background-image: url(../assets/img/demo/3.jpg); }
      .info-container {
        flex: 1;
        display: flex;
        flex-direction: column;

      }
      .common-info {
        text-align: center;
      }
      .contents {
        padding: 10px;
        $contentsRowSize: 245px;
        display: flex;
        align-items: center;
        justify-content:space-around;
        flex-wrap: wrap;
        gap: 10px;

        .youtube {
          width: 300px;
          height: $contentsRowSize;
        }

        $boothSize: 168px;
        .booth {
          display: block;
          width: $boothSize;
          height: $boothSize;
          cursor: pointer;
          overflow: hidden;
          background-image: url(../assets/img/banner/company/booth-l.png);
          @include bgCenter;
          background-size: $boothSize $boothSize;
          transition: 0.2s ease;
          position: relative;

          &:hover {
            background-size: $boothSize*1.1 $boothSize*1.1;
          }
        }
      }
      .tracks {
        flex: 1;
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: left;
      }
    }
  }

  // responsible -----------------------------------------------
  &.viewLg {
    #contents-main {
      .cd-item {
        .common-info {
          .title {
            font-size: 1.5em;

          }
        }
        .tracks { font-size: 1.2em; }
        &.odd {
          flex-direction: row-reverse;
          .contents {
            flex-direction: row-reverse;
          }
          .tracks {
            text-align: right;
          }
        }
      }
    }
  }

  &.viewMd {
    #contents-main {
      .cd-item {
        flex-direction: column;
        .jacket {
          width: 100%;
          height: 400px;
        }
        .common-info {
          .title { font-size: 1.2em; }
        }
        .tracks { text-align: center; }
      }
    }
  }

  &.viewSm {
    #contents-main {
      .cd-item {
        flex-direction: column;
        .jacket {
          width: 100%;
          height: 250px;
        }
        .tracks { text-align: center; }
      }
    }
  }
}
</style>
